import { Pipe, PipeTransform } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { RequirementType } from '../../viewmodels/performance-standard-requirement';

@Pipe({
  name: 'requirementType',
})
export class RequirementTypePipe implements PipeTransform {

  constructor(private i18NextPipe: I18NextPipe) {
  }

  transform(value: RequirementType, args?: any): string {
    return  this.i18NextPipe.transform(this.i18NextPipe.transform(
      'RequirementTypePipe.' + RequirementType[value]));
  }
}